import React, { SVGProps } from 'react';

export default function SvgComponent(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      className="icon_youtube"
      height="1.5em"
      viewBox="0 0 24 24"
      width="1.5em"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx={12} cy={12} fill="#cd201f" r={12} />
      <path
        d="M19.351 8.978a3.281 3.281 0 00-.6-1.5 2.081 2.081 0 00-1.5-.645C15.15 6.683 12 6.683 12 6.683h-.016s-3.134 0-5.25.149a2.19 2.19 0 00-1.485.645 3.275 3.275 0 00-.6 1.5 22.8 22.8 0 00-.15 2.445v1.139a22.854 22.854 0 00.15 2.446 3.263 3.263 0 00.6 1.5 2.437 2.437 0 001.65.645c1.2.12 5.1.165 5.1.165s3.149 0 5.249-.165a2.072 2.072 0 001.5-.645 3.268 3.268 0 00.6-1.5 23 23 0 00.149-2.446v-1.138a22.949 22.949 0 00-.146-2.445zm-9.331 5.549V9.4l4.8 2.52z"
        fill="#fff"
      />
    </svg>
  );
}
